export default __webpack_public_path__ + "static/media/186.c775ba8b.gif";